var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "关键字" },
                model: {
                  value: _vm.paramsData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "name", $$v)
                  },
                  expression: "paramsData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "标识" },
                model: {
                  value: _vm.paramsData.flag,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "flag", $$v)
                  },
                  expression: "paramsData.flag"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 4 } },
            [
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                attrs: {
                  paramsData: _vm.paramsData,
                  filesname: "file",
                  Url: "division/import",
                  title: "批量上传"
                },
                on: {
                  change: function($event) {
                    return _vm.getList()
                  }
                }
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addDivision.init()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" }
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
          _c("el-table-column", { attrs: { prop: "flag", label: "赛区标识" } }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "220",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addDivision.init(scope.row)
                            }
                          }
                        },
                        [_vm._v(" 修改 ")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(scope.row.id)
                            }
                          }
                        },
                        [_vm._v(" 删除 ")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addUserList.init(scope.row)
                            }
                          }
                        },
                        [_vm._v(" 用户列表 ")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total
            },
            on: { "size-change": _vm.sizeChange, "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addDivision", {
        ref: "addDivision",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("addUserList", {
        ref: "addUserList",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }